// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xb-D","left":"styles_left__3QVli","desktopActions":"styles_desktopActions__299m7","title":"styles_title__1MNUF"};